<div class="course-items-switch-wrapper">
    <ng-container [ngSwitch]="display">
        <ng-container *ngSwitchCase="ResourceBuildingItems.SURVEY_LIBRARY">
            <mat-tab-group class="res-tabs-course-item" #tabGroup ngClass.xs="xs">
                <mat-tab>
                    <ng-template mat-tab-label i18n> My surveys </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.SURVEY"
                        context="author"
                        [selection]="selection"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                    >
                        <ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label i18n> Academy surveys </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.SURVEY"
                        context="academy"
                        [selection]="selection"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label i18n> Open library (KOL) </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.SURVEY"
                        context="kol"
                        [selection]="selection"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
        <ng-container *ngSwitchCase="ResourceBuildingItems.CREATE_NEW_SURVEY"
            ><app-course-manager-create-survey
                #compRef
                [resource]="resourceToEdit"
                [publishOnly]="true"
                publishLabel="Add to course"
                i18n-publishLabel
                (published)="add.emit($event)"
                (onError)="onError.emit($event)"
            ></app-course-manager-create-survey
        ></ng-container>
        <ng-container *ngSwitchCase="ResourceBuildingItems.CREATE_NEW_SURVEY_WITH_AI"
            ><app-course-manager-core-ai-questionnaire
                #compRef
                [type_id]="ResourceTypes.GeneralSurvey"
                class="create-test-in-course-manager"
                (published)="add.emit($event)"
                (onError)="onError.emit($event)"
            ></app-course-manager-core-ai-questionnaire
        ></ng-container>
    </ng-container>
    <button
        matTooltip="Trash"
        mat-icon-button
        [ngClass]="display === ResourceBuildingItems.SURVEY_LIBRARY ? 'lib' : 'normal'"
        (click)="display = null; onCloseView.emit(true)"
        i18n-matTooltip
        class="add-creation-tab"
    >
        <mat-icon>cancel</mat-icon>
    </button>
</div>
<ng-template #topSubmitBtn>
    <button
        *ngIf="!!selectedResources?.length"
        class="topsubmitBtn"
        mat-button
        color="primary"
        (click)="onSubmitMultiple()"
    >
        <span i18n>Done ({{ selectedResources?.length }})</span>
    </button>
</ng-template>
